import { Component } from '@angular/core';

import { RequestVerificationCodeComponent } from './request-verification-code/request-verification-code.component';
import { CreatePasswordComponent }          from './create-password/create-password.component';

@Component({
  selector: 'pin-forgot-password',
  templateUrl: './forgot-password.component.html',
  imports: [RequestVerificationCodeComponent, CreatePasswordComponent]
})
export class ForgotPasswordComponent {
  showUsername = true;
  username: string;

  userInput(username: string) {
    this.username = username;
    this.showUsername = false;
  }
}
